import connect from './connect';

export { RemoveMemberModal } from './RemoveMemberModal';

export default connect;
